import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { RootState } from '../../../modules';
import { ContentsItem } from '../../../modules/editor/types';
import { service } from '../../../config';

import ShareToolbar from '../Toolbar/ShareToolbar';
import { editContent } from '../../../modules/editor';

type Props = {
	contentItem: ContentsItem
};

const ShareItem = (item:any) => {	
	if (!item.active) { 
		return null;
	}

	return (
		<span
			style={{
				padding: '0 10px',
				display: 'inline-block',
			}}	
		>
			<img 
				src={`${service.resource}/editor/icon/share/${item.value}-${item.snsStyle}.png`} 
				alt={item.alt} 
				width="20"
				style={{
					verticalAlign: 'middle'
				}}
			/>
			<span
				style={{
					verticalAlign: 'middle',
					color: '#606165',
					fontSize: '12px',
					display: 'inline-block',
					margin: '0 0 0 6px'
				}}
			>
				{item.label}
			</span>
		</span>
	)
}

function Share({ contentItem }: Props) {
	const [showToolbar, setShowToolbar] = useState(false);	
	const dispatch = useDispatch();
	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);

	useEffect(() => {
		if (selectedContentId !== contentItem.id) {
			unselectContent();
		}
	}, [selectedContentId]);

	useEffect(() => {
		if (contentItem.id < 0) return;
		const { share } = contentItem.content.content[0];
		const newServices = [...share].map((sns) => {
			if (sns.value !== 'twitter') return sns;
			if (sns.label !== '트윗하기') return sns;
			return { ...sns, label: '게시하기' };
		});
		dispatch(editContent({ target: `${contentItem.id}/content/0/share`, data: newServices }));
	}, [contentItem.id]);

	const startEditing = () => {
		setShowToolbar(true);
	}

	const unselectContent = () => {
		setShowToolbar(false);
	}

	return (
		<div className={showToolbar ? 'share-edit active' : 'share-edit'}>
			<div className="share-edit-content">
				{
					contentItem.content.content[0].share.map((item:any, index:number) => (
						<ShareItem key={index} {...item} snsStyle={contentItem.content.style[0].box.snsStyle} />
					))
				}
			</div>
			{
				showToolbar ? (
					<ShareToolbar
						innerContent={contentItem.content.content[0]}
						style={contentItem.content.style[0].box}
						contentId={contentItem.id}
						contentIndex={0}
					/>
				) : (
					<div
						className="cover"
						onClick={startEditing}
					>
					</div>
				)
			}
		</div>
	)
}

export default Share;